/* SilcoCollectionPage — client-side faceted filtering for the SILCO
   collection template (design handoff: Category v2).
   Groups are AND-combined, options within a group OR-combined. Facet counts
   are live: each option's count = products matching every OTHER active group
   plus that option (its own group excluded). State syncs to URL query params
   (?category=&artist=&country=&avail=&price=&sort=&view=). Vanilla JS, one
   isolated instance per section root — Theme Editor re-renders re-init via
   shopify:section:load. */
(function () {
  var GROUPS = ['category', 'artist', 'country', 'avail', 'price'];

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-silco-collection]').forEach(init);
  }

  function init(root) {
    if (root.silcoCollectionInit) return;
    root.silcoCollectionInit = true;

    var t1 = parseFloat(root.dataset.priceT1 || '250');
    var t2 = parseFloat(root.dataset.priceT2 || '750');
    var itemWord = root.dataset.itemWord || 'objects';
    var itemWordOne = root.dataset.itemWordOne || itemWord.replace(/s$/, '');

    var cards = Array.prototype.map.call(
      root.querySelectorAll('[data-sc-card]'),
      function (el, i) {
        return {
          el: el,
          index: i,
          cat: el.dataset.cat || '',
          artist: el.dataset.artist || '',
          country: el.dataset.country || '',
          sold: el.dataset.sold === '1',
          mto: el.dataset.mto === '1',
          price: parseFloat(el.dataset.price || '0'),
        };
      }
    );

    var state = {
      category: [], artist: [], country: [], avail: [], price: [],
      sort: root.dataset.defaultSort || 'featured',
      cols: parseInt(root.dataset.defaultCols || '3', 10),
      sortOpen: false, mFiltersOpen: false, mSortOpen: false, expArtists: false,
    };

    // ---- URL → state ----
    var params = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) {
      var v = params.get(g === 'category' ? 'category' : g);
      if (v) state[g] = v.split(',').filter(Boolean);
    });
    if (params.get('sort')) state.sort = params.get('sort');
    if (params.get('view')) state.cols = parseInt(params.get('view'), 10) || state.cols;

    function syncUrl() {
      var p = new URLSearchParams(window.location.search);
      GROUPS.forEach(function (g) {
        if (state[g].length) p.set(g, state[g].join(','));
        else p.delete(g);
      });
      if (state.sort !== (root.dataset.defaultSort || 'featured')) p.set('sort', state.sort);
      else p.delete('sort');
      if (state.cols !== parseInt(root.dataset.defaultCols || '3', 10)) p.set('view', String(state.cols));
      else p.delete('view');
      var q = p.toString();
      window.history.replaceState({}, '', window.location.pathname + (q ? '?' + q : ''));
    }

    function priceRange(key, v) {
      if (key === 'p1') return v < t1;
      if (key === 'p2') return v >= t1 && v <= t2;
      return v > t2;
    }

    function optionPred(group, value, card) {
      if (group === 'category') return card.cat === value;
      if (group === 'artist') return card.artist === value;
      if (group === 'country') return card.country === value;
      if (group === 'avail') return value === 'stock' ? (!card.sold && !card.mto) : card.mto;
      return priceRange(value, card.price);
    }

    function matches(card, skip) {
      return GROUPS.every(function (g) {
        if (g === skip || !state[g].length) return true;
        return state[g].some(function (v) { return optionPred(g, v, card); });
      });
    }

    function activeCount() {
      return GROUPS.reduce(function (n, g) { return n + state[g].length; }, 0);
    }

    function render() {
      var list = cards.filter(function (c) { return matches(c, null); });

      // sort → order value per card (grid `order`)
      var sorted = list.slice();
      if (state.sort === 'priceAsc') sorted.sort(function (a, b) { return a.price - b.price; });
      if (state.sort === 'priceDesc') sorted.sort(function (a, b) { return b.price - a.price; });
      if (state.sort === 'newest') sorted.reverse();
      var orderOf = {};
      sorted.forEach(function (c, i) { orderOf[c.index] = i; });

      cards.forEach(function (c) {
        var show = orderOf[c.index] !== undefined;
        c.el.style.display = show ? '' : 'none';
        c.el.style.order = show ? String(orderOf[c.index]) : '';
      });

      // counts + empty state
      var n = list.length;
      var word = n === 1 ? itemWordOne : itemWord;
      root.querySelectorAll('[data-sc-count]').forEach(function (el) {
        el.textContent = n + ' ' + word;
      });
      root.querySelectorAll('[data-sc-empty]').forEach(function (el) {
        el.style.display = n === 0 ? '' : 'none';
      });
      root.querySelectorAll('[data-sc-grid]').forEach(function (el) {
        el.style.display = n === 0 ? 'none' : '';
        el.style.setProperty('--sc-cols', String(state.cols));
      });

      // checkboxes + facet counts (both sidebar and mobile panel copies)
      root.querySelectorAll('[data-sc-opt]').forEach(function (label) {
        var g = label.dataset.group;
        var v = label.dataset.value;
        var input = label.querySelector('input');
        if (input) input.checked = state[g].indexOf(v) !== -1;
        var countEl = label.querySelector('[data-sc-opt-count]');
        if (countEl) {
          var c = cards.filter(function (card) {
            return matches(card, g) && optionPred(g, v, card);
          }).length;
          countEl.textContent = String(c);
        }
      });

      // clear-all visibility
      var nActive = activeCount();
      root.querySelectorAll('[data-sc-clear-wrap]').forEach(function (el) {
        el.style.display = nActive > 0 ? '' : 'none';
      });

      // view toggle buttons
      root.querySelectorAll('[data-sc-view]').forEach(function (btn) {
        var active = parseInt(btn.dataset.scView, 10) === state.cols;
        btn.style.color = active ? '#111113' : '#A1A1AA';
        btn.style.borderBottom = active ? '1px solid #111113' : '1px solid transparent';
      });

      // sort label + option marks
      var sortLabels = { featured: 'Featured', newest: 'Newest', priceAsc: 'Price, low to high', priceDesc: 'Price, high to low' };
      root.querySelectorAll('[data-sc-sort-label]').forEach(function (el) {
        el.textContent = sortLabels[state.sort] || 'Featured';
      });
      root.querySelectorAll('[data-sc-sort-opt]').forEach(function (btn) {
        var mark = btn.querySelector('[data-sc-mark]');
        if (mark) mark.textContent = btn.dataset.scSortOpt === state.sort ? '✓' : '';
      });

      // dropdown / panel visibility
      toggleEl('[data-sc-sort-dropdown]', state.sortOpen);
      toggleEl('[data-sc-msort]', state.mSortOpen);
      toggleEl('[data-sc-mfilters]', state.mFiltersOpen);

      // mobile labels
      root.querySelectorAll('[data-sc-mfilter-label]').forEach(function (el) {
        el.textContent = nActive > 0 ? 'Filter (' + nActive + ') +' : 'Filter +';
      });
      root.querySelectorAll('[data-sc-show-label]').forEach(function (el) {
        el.textContent = 'Show ' + n + ' ' + word;
      });

      // artist show more
      var moreBtn = root.querySelector('[data-sc-artists-more]');
      if (moreBtn) {
        var hiddenCount = parseInt(moreBtn.dataset.hiddenCount || '0', 10);
        moreBtn.textContent = state.expArtists ? 'Show less' : 'Show ' + hiddenCount + ' more';
      }
      root.querySelectorAll('[data-sc-artist-extra]').forEach(function (el) {
        el.style.display = state.expArtists ? '' : 'none';
      });

      syncUrl();
    }

    function toggleEl(sel, show) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.style.display = show ? '' : 'none';
      });
    }

    // ---- events ----
    root.addEventListener('change', function (e) {
      var label = e.target.closest && e.target.closest('[data-sc-opt]');
      if (!label) return;
      var g = label.dataset.group;
      var v = label.dataset.value;
      var i = state[g].indexOf(v);
      if (i === -1) state[g].push(v);
      else state[g].splice(i, 1);
      render();
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button, [data-sc-clear]');
      if (!btn) return;
      if (btn.hasAttribute('data-sc-clear')) {
        GROUPS.forEach(function (g) { state[g] = []; });
        render();
      } else if (btn.hasAttribute('data-sc-view')) {
        state.cols = parseInt(btn.dataset.scView, 10);
        render();
      } else if (btn.hasAttribute('data-sc-sort-toggle')) {
        state.sortOpen = !state.sortOpen;
        render();
      } else if (btn.hasAttribute('data-sc-sort-opt')) {
        state.sort = btn.dataset.scSortOpt;
        state.sortOpen = false;
        state.mSortOpen = false;
        render();
      } else if (btn.hasAttribute('data-sc-mfilters-toggle')) {
        state.mFiltersOpen = !state.mFiltersOpen;
        state.mSortOpen = false;
        render();
      } else if (btn.hasAttribute('data-sc-mfilters-close')) {
        state.mFiltersOpen = false;
        render();
      } else if (btn.hasAttribute('data-sc-msort-toggle')) {
        state.mSortOpen = !state.mSortOpen;
        state.mFiltersOpen = false;
        render();
      } else if (btn.hasAttribute('data-sc-artists-more')) {
        state.expArtists = !state.expArtists;
        render();
      }
    });

    // close the desktop sort dropdown on outside click / Escape
    document.addEventListener('click', function (e) {
      if (!state.sortOpen) return;
      if (!e.target.closest || !e.target.closest('[data-sc-sort-wrap]')) {
        state.sortOpen = false;
        render();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && (state.sortOpen || state.mFiltersOpen || state.mSortOpen)) {
        state.sortOpen = state.mFiltersOpen = state.mSortOpen = false;
        render();
      }
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
